// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"cola"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M21.1893 11.2879L11.2898 21.1874L2.81055 12.7081L12.7101 2.80859L21.1893 11.2879Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill2"},"nodeName":"g","children":[{"attributes":{"fill":"transparent","d":"M2.10107 16.2415L2.81011 12.7082L11.2894 21.1875L7.75792 21.8984L2.10107 16.2415Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"transparent","d":"M16.243 2.09961L21.8998 7.75646L21.1889 11.288L12.7096 2.80871L16.243 2.09961Z"},"nodeName":"path","children":[]}]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M18.0092 8.1084C16.0242 10.6234 11.6098 14.5079 3.87012 13.7683M18.3645 14.1205C17.0804 15.4046 13.2535 17.9517 7.04984 16.948","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M13.2 3.29909L20.7009 10.8M3.30002 13.2L10.8009 20.7008M12.7096 2.80871L16.243 2.09961L21.8998 7.75646L21.1889 11.288L11.2894 21.1875L7.75792 21.8984L2.10107 16.2415L2.81011 12.7082L12.7096 2.80871Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-cola')
export default class ColaIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'cola',
    }
  }
}
